
import Router from './Routes/router';

const App = () => {
  return (
    <div>
      <Router />
    </div>
  )
}

export default App
